class Drawer extends HTMLElement {
    constructor() {
        super();
        this.init();
    }
    setListeners() {

        this.details = this.querySelector('[data-details]')
        this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
        this.querySelector('[data-overlay]')?.addEventListener('click', () => {
            this.close.bind(this)()
        });
        const closeBtns = this.querySelectorAll('[data-drawer-close]');
        closeBtns?.forEach(btn => btn.addEventListener('click', this.close.bind(this)));

        subscribe(PUB_SUB_EVENTS.onCloseDrawerEvent, (event) => {
            this.handleExternalClose(event.target);
        });
    }

    setIconAccessibility(detailsLink) {

        detailsLink.setAttribute('role', 'button');
        detailsLink.setAttribute('aria-haspopup', 'dialog');
        detailsLink.addEventListener('click', (event) => {
            event.preventDefault();
            this.open(detailsLink);
        });
        this.addEventListener('keydown', (event) => {
            if (event.code.toUpperCase() === 'SPACE') {
                this.open(this);
            }
        });
    }

    init() {
        this.overlay = this;
        this.dialog = this.querySelector('[data-modal-dialog]');
        this.closeBtn = this.querySelector('[data-modal-close]');
        this.isOpen = false;

        this.close = this.close.bind(this);
        this.open = this.open.bind(this);

        // Escape key
        document.addEventListener('keyup', (e) => {
            if (this.isOpen && e.code === 'Escape') this.close();
        });

        // Close on overlay click
        this.overlay.addEventListener('click', (e) => {
            if (e.target === this.overlay) this.close();
        });

        // Close button
        this.closeBtn?.addEventListener('click', this.close);
    }

    open(triggeredBy) {
        if (triggeredBy) this.setActiveElement(triggeredBy);
        setTimeout(() => {
            this.classList.add('animate');
            this.setAttribute('open', '');
        });
        this.classList.remove('tw-opacity-0', 'tw-pointer-events-none');
        this.classList.add('tw-opacity-100');
        document.body.classList.add('overflow-hidden');
        this.setAttribute('open', '');
        this.isOpen = true;
    }

    setActiveElement(element) {
        this.activeElement = element;
    }

    close() {
        this.classList.add('tw-opacity-0', 'tw-pointer-events-none');
        this.classList.remove('tw-opacity-100');
        document.body.classList.remove('overflow-hidden');
        this.removeAttribute('open');
        this.isOpen = false;
    }

    handleExternalClose(source) {
        const type = this.dataset.type;
        if (!type || type !== source) return;
        this.close();
    }
}

class DrawerCloser extends HTMLElement {
    constructor() { super() }

    connectedCallback() {
        this.onClose = this.addEventListener('click', () => {
            publish(PUB_SUB_EVENTS.onCloseDrawerEvent, {
                target: this.dataset.type
            });
        });
    }

    disconnectedCallback() {
        this.onClose && this.onClose();
    }
}

customElements.define('drawer-closer', DrawerCloser);